<div class="bl-max-width--tablet-width bl-margin-x--auto" data-automation-id="user-verification-error-card">
  <dx-content-messaging-card
    [title]="pageContent.title || ('userVerificationError/heading' | dictionary)"
    [description]="pageContent.description || ('userVerificationError/subheading' | dictionary)"
    [showAddress]="pageContent.showAddressBlock"
    [showPhone]="pageContent.showPhoneBlock"
    [showEmail]="pageContent.showEmailBlock"
    [addressLabel]="pageContent.addressBlockLabel"
    [phoneLabel]="pageContent.phoneBlockLabel"
    [emailLabel]="pageContent.emailBlockLabel"
  ></dx-content-messaging-card>
</div>
